import { SVGProps, memo } from 'react';

const SendIcon = (props: SVGProps<SVGSVGElement>) => (
<svg width={props.width || "18"} height={props.height || "19"} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5111 17.5486C10.7813 17.7844 11.2047 17.6675 11.3155 17.3263L16.1886 2.31847C16.3243 1.90044 15.8934 1.52324 15.497 1.71311L1.26616 8.5296C0.942671 8.68455 0.882739 9.11965 1.15229 9.35629L4.35889 12.1713C4.53524 12.3261 4.79552 12.3375 4.98467 12.1986L10.4273 8.20243L7.18662 14.1261C7.074 14.3319 7.11969 14.5884 7.29648 14.7427L10.5111 17.5486Z" stroke={props.color || "white"} stroke-width="1.6" stroke-linejoin="round"/>
</svg>

);

export default memo(SendIcon);
